module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enable_this_courier":"Enable this courier","set_preferred_delivery":"Set as preferred delivery option","select_parcel_delivery":"Select parcel delivery method"},"id":{"enable_this_courier":"Aktifkan kurir ini","set_preferred_delivery":"Atur sebagai pilihan pengiriman yang disukai","select_parcel_delivery":"Pilih metode pengiriman paket"}}')
  delete Component.options._Ctor
}
